/* eslint-disable @typescript-eslint/naming-convention */
import type { Func } from "@react-awesome-query-builder/core";

const DATE_SUBTRACTION: Func = {
  label: "DATE SUBTRACTION",
  returnType: "date",
  jsonLogic: "DATE_SUBTRACTION",
  sqlFunc: "DATE_SUBTRACTION",
  args: {
    date: {
      label: "Date",
      type: "date",
      valueSources: ["value", "field", 'func'],
    },
    days: {
      label: "Days",
      type: "number",
      valueSources: ["value", "field", 'func'],
    },
  },
  formatFunc: (formattedArgs) =>
    `DATE_SUBTRACTION(${formattedArgs.date},${formattedArgs.days})`,
  sqlFormatFunc: (formattedArgs) =>
    `DATE_SUBTRACTION(${formattedArgs.date},${formattedArgs.days})`,
};

export default DATE_SUBTRACTION;